export default {
    summerprize: 'summerprize/testRightNum',
    gameNum: 'summerprize/gameNum'
};
